"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _FormInput = _interopRequireDefault(require("../Forms/FormInput"));

var _FormLabel = _interopRequireDefault(require("../Forms/FormLabel"));

var _FormTextarea = _interopRequireDefault(require("../Forms/FormTextarea"));

var _Menu = _interopRequireDefault(require("../Menu/Menu"));

var _Popover = _interopRequireDefault(require("../Popover/Popover"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _inputGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/input-group.css") : void 0);

var _localizationEditor = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/localization-editor.css") : void 0);

var _menu = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/menu.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; (0, _forEach.default)(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source))).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread(_objectSpread({}, _menu.default), _inputGroup.default), _localizationEditor.default));
var isUsingCssModules = _localizationEditor.default && (0, _keys.default)(_localizationEditor.default).length > 0;

var LocalizationEditor = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var control = _ref.control,
      menu = _ref.menu,
      id = _ref.id,
      compact = _ref.compact,
      textarea = _ref.textarea,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      inputClassName = _ref.inputClassName,
      listProps = _ref.listProps,
      popoverProps = _ref.popoverProps,
      props = (0, _objectWithoutProperties2.default)(_ref, ["control", "menu", "id", "compact", "textarea", "className", "cssNamespace", "inputClassName", "listProps", "popoverProps"]);
  var localizationEditorClasses = classnames("".concat(cssNamespace, "-localization-editor"), className);
  var localizationInputClasses = classnames("".concat(cssNamespace, "-input-group__input"), (0, _defineProperty3.default)({}, "".concat(cssNamespace, "-textarea"), textarea && isUsingCssModules), inputClassName);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: localizationEditorClasses,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_FormLabel.default, (0, _extends2.default)({}, control.labelProps, {
    htmlFor: id
  }), control.label), /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({}, popoverProps, {
    body: /*#__PURE__*/_react.default.createElement(_Menu.default, null, /*#__PURE__*/_react.default.createElement(_Menu.default.List, listProps, (0, _map.default)(menu).call(menu, function (item, index) {
      var inputProps = item.inputProps,
          language = item.language,
          placeholder = item.placeholder,
          itemProps = (0, _objectWithoutProperties2.default)(item, ["inputProps", "language", "placeholder"]);
      return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, itemProps, {
        className: classnames("".concat(cssNamespace, "-menu__item")),
        key: index
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-input-group"), "".concat(cssNamespace, "-input-group--after"))
      }, textarea ? /*#__PURE__*/_react.default.createElement(_FormTextarea.default, (0, _extends2.default)({}, inputProps, {
        className: localizationInputClasses
      })) : /*#__PURE__*/_react.default.createElement(_FormInput.default, (0, _extends2.default)({}, inputProps, {
        className: localizationInputClasses,
        compact: compact,
        placeholder: placeholder
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: classnames("".concat(cssNamespace, "-input-group__addon"), "".concat(cssNamespace, "-input-group__addon--button"))
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: classnames("".concat(cssNamespace, "-input-group__button")),
        compact: compact,
        option: "transparent"
      }, language))));
    }))),
    control: /*#__PURE__*/_react.default.createElement("div", {
      className: classnames("".concat(cssNamespace, "-input-group"), "".concat(cssNamespace, "-input-group--after"))
    }, textarea ? /*#__PURE__*/_react.default.createElement(_FormTextarea.default, (0, _extends2.default)({}, control.inputProps, {
      className: localizationInputClasses,
      compact: compact
    })) : /*#__PURE__*/_react.default.createElement(_FormInput.default, (0, _extends2.default)({}, control.inputProps, {
      className: localizationInputClasses,
      compact: compact,
      placeholder: control.placeholder
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: classnames("".concat(cssNamespace, "-input-group__addon"), "".concat(cssNamespace, "-input-group__addon--button"))
    }, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, control.buttonProps, {
      className: classnames("".concat(cssNamespace, "-input-group__button")),
      compact: compact,
      option: "transparent"
    }), control.language))),
    disableKeyPressHandler: true,
    id: id,
    noArrow: true
  })));
});

LocalizationEditor.displayName = 'LocalizationEditor';
process.env.NODE_ENV !== "production" ? LocalizationEditor.propTypes = {
  /** A collection of properties to apply to the `<label>`, `<input>`/`<textarea>` and `<button>` elements. */
  control: _propTypes.default.shape({
    /** Additional props to be spread to the `<button>` element */
    buttonProps: _propTypes.default.object,

    /** Additional props to be spread to the `<input>` element */
    inputProps: _propTypes.default.object,

    /** Additional props to be spread to the `<label>` element */
    labelProps: _propTypes.default.object,

    /** Localized text for the `<label>` element */
    label: _propTypes.default.string,

    /** Localized placeholder text of the input */
    placeholder: _propTypes.default.string,
    language: _propTypes.default.string
  }).isRequired,

  /** An array of objects that represent the values of the elements in the dropdown menu. The shape of the objects in the array is `{ placeholder: string, language: string, inputProps: object }` */
  menu: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Additional props to be spread to the `<input>` element */
    inputProps: _propTypes.default.object,

    /** Localized placeholder text of the input */
    placeholder: _propTypes.default.string,

    /** Text to display on the `<button>` element. Meant to be the language of the text in the `<input>`/`<textarea>` element */
    language: _propTypes.default.string
  }).isRequired).isRequired,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Value for the `id` attribute on the element */
  id: _propTypes.default.string,

  /** CSS class(es) to add to the `<input>` element */
  inputClassName: _propTypes.default.string,

  /** Additional props to be spread to the `<ul>` element */
  listProps: _propTypes.default.object,

  /** Additional props to be spread to the Popover component */
  popoverProps: _propTypes.default.object,

  /** Set to **true** to enable a Localization Editor with a textarea */
  textarea: _propTypes.default.bool
} : void 0;

var _default = (0, _withStyles.default)(LocalizationEditor);

exports.default = _default;